import { Link } from "react-router-dom";
import { ArrowRight, ChevronRight } from "lucide-react";
import Navbar from "@/components/Navbar";
import CaseStudiesSection from "@/components/CaseStudiesSection";
import Footer from "@/components/Footer";
import ServicesSection from "@/components/ServicesSection";
import IndustriesSection from "@/components/IndustriesSection";
import { MorphPanel } from "@/components/ui/ai-input";

export default function ExpertisePage({ kind }) {
  const isServices = kind === "services";
  const label = isServices ? "Services" : "Industries";
  return (
    <div className="min-h-screen bg-void">
      <Navbar />
      <main className="pt-28 expertise-page">
        <nav aria-label="Breadcrumb" className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24 flex items-center gap-3 text-sm text-muted-foreground">
          <Link to="/" className="hover:text-white">Home</Link>
          <ChevronRight size={14} aria-hidden="true" />
          <span aria-current="page" className="text-white">{label}</span>
        </nav>
        {isServices ? <ServicesSection standalone /> : <IndustriesSection standalone />}
        <CaseStudiesSection />
        <section className="border-t border-white/10 py-20 md:py-24">
          <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-24">
            <div className="grid md:grid-cols-2 gap-8 md:gap-16 items-start">
              <h2 className="section-title !leading-tight">{isServices ? "Find the right AI solution for your business." : "Bring your industry challenge to us."}</h2>
              <div>
                <p className="section-subtitle mb-8">{isServices ? "Tell us what you want to build. We’ll help map your goals to the right AI approach, from discovery through integration and ongoing support." : "Every business has different workflows, data, and goals. Let’s explore where a custom AI solution fits yours."}</p>
                <div className="flex flex-wrap items-center gap-6">
                  <Link to="/#booking" className="btn-primary inline-flex items-center gap-2">Book Consultation <ArrowRight size={18} aria-hidden="true" /></Link>
                  <Link to={isServices ? "/industries" : "/services"} className="text-neon-cyan inline-flex items-center gap-2 hover:underline">{isServices ? "Explore industries" : "Explore services"}<ArrowRight size={18} aria-hidden="true" /></Link>
                </div>
                <Link to="/#process" className="inline-block mt-8 text-muted-foreground hover:text-white underline underline-offset-4">See how we work</Link>
              </div>
            </div>
          </div>
        </section>
      </main>
      <Footer />
      <MorphPanel />
    </div>
  );
}
